import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { productList } from "constants/product";

export const getProductList = async (
  dispatch,
  { pageNum, filters = null, searchString } = {},
) => {
  try {
    const res = await api.product_list(pageNum, filters, searchString);
    dispatch({ type: productList, payload: res.data });
  } catch (error) {
    dispatch({ type: productList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

export const getproductbyID = async (id) => {
  try {
    const res = await api.get_product_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const addProduct = async (bodyData) => {
  try {
    const res = await api.add_product(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const editProduct = async (id, bodyData) => {
  try {
    const res = await api.edit_product(id, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//get product data in csv file
export const exportProductData = async ({ filters = null, searchString }) => {
  try {
    const res = await api.product_csv_export(filters, searchString);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const downloadProductManual = async (productDocumentID, type) => {
  try {
    const res = await api.download_product_manual(productDocumentID, type)
    return res;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: "Failed to download product manual. Please try again.",
      }
    );
  }
}